var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
import TicketReference from "./TicketReference";
import { TemplateTicketDesign } from "./TemplateTicketDesign";
import { OrderExtras } from "../Order/OrderExtras";
import moment from "moment";
var Ticket = /** @class */ (function (_super) {
    __extends(Ticket, _super);
    function Ticket(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.creationDate = '';
        _this.finalized = false;
        _this.reference = [];
        _this.templateTicketDesigns = [];
        // Not Used = 0
        // Validate Offline = 100
        // Validate Online = 200
        // Invalid Signature = 400
        // Already Used = 406
        _this.status = 0;
        _this.onlineStatus = 'VALID';
        /** 0 -> IN && 1 -> OUT && null-> never use **/
        // const VALID = 0;
        // const EXPIRED = 1;
        // const CANCELED = 2;
        _this._lastUpdateType = null;
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        Ticket.buildFromJson(_this, obj);
        return _this;
    }
    Ticket.prototype.validatedOffline = function () {
        this.status = 100;
    };
    Ticket.prototype.validatedOnline = function () {
        this.status = 200;
    };
    Ticket.prototype.signatureIsInvalid = function () {
        this.status = 400;
    };
    Ticket.prototype.limitReached = function () {
        this.status = 406;
    };
    Ticket.prototype.isOfflineValidated = function () {
        return this.status === 100;
    };
    Ticket.prototype.isOnlineValidated = function () {
        return this.status === 200;
    };
    Ticket.prototype.isLimitReaches = function () {
        return this.status === 406;
    };
    Ticket.prototype.isInvalid = function () {
        return this.status === 400;
    };
    Ticket.prototype.isValid = function () {
        return this.isOfflineValidated() || this.isOnlineValidated();
    };
    Ticket.prototype.isUsed = function () {
        return this.isOfflineValidated() || this.isOnlineValidated();
    };
    Ticket.prototype.isAvailable = function () {
        return this.status = 0;
    };
    Object.defineProperty(Ticket.prototype, "lastUpdateType", {
        get: function () {
            return this._lastUpdateType;
        },
        set: function (value) {
            this._lastUpdateType = value;
            if (value === 0) {
                this.validatedOnline();
            }
        },
        enumerable: false,
        configurable: true
    });
    Ticket.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                // console.log("ici",prop === 'qrPayload',json[prop]);
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'reference') {
                        for (var _i = 0, _a = json[prop]; _i < _a.length; _i++) {
                            var subProp = _a[_i];
                            instance.reference.push(new TicketReference(subProp));
                        }
                    }
                    else if (prop === 'priceWithTax' || prop === 'price') {
                        instance[prop] = json[prop];
                    }
                    else if (prop === 'orderExtras') {
                        instance[prop] = new OrderExtras(json[prop]);
                    }
                    else if (prop === 'qrPayload') {
                        // instance["qrPayload"]=[];
                        instance[prop] = json[prop];
                        // for (let subProp in json[prop]) {
                        // 	instance.qrPayload.push(json[prop][subProp]);
                        // }
                        console.log("here", json[prop], instance);
                    }
                    else if (prop === 'templateTicketDesigns') {
                        for (var _b = 0, _c = json[prop]; _b < _c.length; _b++) {
                            var subProp = _c[_b];
                            instance.templateTicketDesigns.push(new TemplateTicketDesign(subProp));
                        }
                    }
                    else if (prop === 'lastUpdateDate') {
                        if (json[prop] !== null) {
                            instance.lastUpdateDate = new Date(json[prop]);
                        }
                        else {
                            instance.lastUpdateDate = json[prop];
                        }
                    }
                    else if (prop === 'status') {
                        instance['onlineStatus'] = json[prop];
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    };
    Ticket.prototype.exportToJson = function () {
        var JSONTicket = {};
        JSONTicket['uid'] = this.uid;
        JSONTicket['creationDate'] = this.creationDate;
        JSONTicket['finalized'] = this.finalized;
        JSONTicket['orderUid'] = this.orderUid;
        JSONTicket['quickCode'] = this.quickCode;
        JSONTicket['shortcode'] = this.shortcode;
        JSONTicket['lastUpdateType'] = this._lastUpdateType === 400 ? 0 : this._lastUpdateType;
        JSONTicket['lastUpdateDate'] = this.lastUpdateDate;
        JSONTicket['ownerName'] = this.ownerName;
        JSONTicket['reference'] = [];
        for (var ref in this.reference) {
            JSONTicket['reference'].push(this.reference[ref].exportToJson());
        }
        if (this.validStartingDate)
            JSONTicket['validStartingDate'] = this.validStartingDate;
        if (this.validEndingDate)
            JSONTicket['validEndingDate'] = this.validEndingDate;
        JSONTicket['ownerUid'] = this.ownerUid;
        return JSONTicket;
    };
    Ticket.prototype.isAlreadyUsed = function () {
        return this._lastUpdateType === 0 || this._lastUpdateType === 1;
    };
    Ticket.prototype.isAnonyme = function () {
        return this.ownerName === ' ' || this.ownerName === '';
    };
    Ticket.sortTickets = function (tickets) {
        /**
         * Les tickets sont triés au début les tickets utilisés à la fin les non utilisés
         * **/
        if (tickets.length > 0) {
            tickets.sort(function (obj1, obj2) {
                return (obj2.isAlreadyUsed() === obj1.isAlreadyUsed()) ? 0 : obj2.isAlreadyUsed() ? -1 : 1;
            });
        }
        return tickets;
    };
    Ticket.getUuidsOftickets = function (tickets) {
        var uuids = [];
        for (var _i = 0, tickets_1 = tickets; _i < tickets_1.length; _i++) {
            var ticket = tickets_1[_i];
            if (ticket.uid) {
                uuids.push(ticket.uid);
            }
        }
        return uuids;
    };
    Ticket.getUuidsOfTemplateTickets = function (tickets) {
        var uuids = [];
        for (var _i = 0, tickets_2 = tickets; _i < tickets_2.length; _i++) {
            var ticket = tickets_2[_i];
            if (ticket.templateTicketUid) {
                uuids.push(ticket.templateTicketUid);
            }
        }
        return uuids;
    };
    Ticket.prototype.canBeReplaced = function (dateTimestamp, stock) {
        if (stock) {
            if (stock.allowDateReplacementBeforeDelta === 0 && stock.allowDateReplacementAfterDelta === 0
                || !(dateTimestamp >= moment(this.validStartingDate).unix() - stock.allowDateReplacementBeforeDelta
                    && dateTimestamp <= moment(this.validStartingDate).unix() + stock.allowDateReplacementAfterDelta)) {
                return false;
            }
            else {
                return true;
            }
        }
        return false;
    };
    Ticket.prototype.allowedReplacementRange = function (stock) {
        return {
            start: moment(this.validStartingDate).unix() - stock.allowDateReplacementBeforeDelta,
            end: moment(this.validStartingDate).unix() + stock.allowDateReplacementAfterDelta
        };
    };
    Ticket.getCorrespondingTicket = function (ticketUid, tickets) {
        for (var _i = 0, tickets_3 = tickets; _i < tickets_3.length; _i++) {
            var ticket = tickets_3[_i];
            if (ticket.uid === ticketUid) {
                return ticket;
            }
        }
        return null;
    };
    return Ticket;
}(Model));
export default Ticket;
//# sourceMappingURL=Ticket.js.map